<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="身份：">
        <el-select v-model="query.levelId" placeholder="请选择" clearable size="small" v-if="isServiceTeacher">
          <el-option label="总监" :value="1"></el-option>
          <el-option label="带教老师" :value="4"></el-option>
        </el-select>
        <el-select v-model="query.levelId" placeholder="请选择" clearable size="small" v-else>
          <el-option v-for="(item,index) in technicalServiceLevel" :key="index" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业绩筛选：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import technicianInfoApi from '@/api/technical/technicianInfo'
export default {
  props: ['isServiceTeacher'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        levelId: null,
        // status:null
      },
      technicalServiceLevel: [],
      topicClassOptions: [],
    }
  },
  created() {
    this.getLevel()
  },
  methods: {
    getLevel() {
      technicalServiceLevelApi.findOptions().then(({data}) => {
        this.technicalServiceLevel = data
      })
    },
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      // this.query.levelIsOrdinary = true;
      // this.query.teamCouSortSign = -1;
      let Ins = this.isServiceTeacher ? technicianInfoApi.exportExcelDataStatisticsBig: technicianInfoApi.exportExcelDataStatistics
      return this.$common.confirm('是否确认导出')
        .then(() => Ins(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
